import React from "react";

import Icon from "../../icons/Icon";
import StyledDivs from "../StyledDivs";

const Notes = ({ notes }) => {
    const notesText =
        notes && notes.length > 0
            ? notes.find((item) => item.text_id === 5)
            : null;

    if (!notesText) {
        return null;
    }

    return (
        <StyledDivs.SubItemsWithIcon>
            <StyledDivs.IconWrapper>
                <Icon iconName="warning" />
            </StyledDivs.IconWrapper>
            <StyledDivs.SubItems>
                <StyledDivs.SubItemHeadline>
                    Hinweise:
                </StyledDivs.SubItemHeadline>
                <div>{notesText.text_value}</div>
            </StyledDivs.SubItems>
        </StyledDivs.SubItemsWithIcon>
    );
};

export default Notes;
